import { useState } from "react";

export const UserAvatar = ({ name = "", src, className = "", size = 36 }) => {
	const [imgError, setImgError] = useState(false);

	const initials = name
		.split(" ")
		.map((n) => n[0])
		.join("")
		.toUpperCase()
		.slice(0, 2);

	const style = {
		minWidth: `${size}px`,
		minHeight: `${size}px`,
		width: `${size}px`,
		height: `${size}px`,
	};

	if (!src || imgError || (src && src.includes("images/avatar.png"))) {
		return (
			<div
				style={style}
				className={`select-none rounded-full bg-primary-100 text-primary flex items-center justify-center text-label font-semibold ${className}`}
			>
				{initials || "?"}
			</div>
		);
	}

	return (
		<img
			src={src}
			alt={name}
			onError={() => setImgError(true)}
			style={style}
			className={`rounded-full object-cover bg-white ${className}`}
		/>
	);
};

export default UserAvatar;